import { useState } from "react";
import { Clock } from "lucide-react";
import { toast } from "sonner";
import { updateDayUseOffer, inviteDayUse } from "@/lib/api";

const DUREES = [2, 3, 4, 6];

export const DayUseOfferCard = ({ hotel, onChanged }) => {
  const cfg = hotel.offre_par_heure || {};
  const [form, setForm] = useState({ actif: !!cfg.actif, heure_debut: cfg.heure_debut ?? 9, heure_fin: cfg.heure_fin ?? 18, reduction: cfg.reduction ?? 30, durees: cfg.durees || DUREES });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const toggleDuree = (d) => set("durees", form.durees.includes(d) ? form.durees.filter((x) => x !== d) : [...form.durees, d].sort());

  const save = async () => {
    setBusy(true);
    try {
      await updateDayUseOffer(hotel.id, form);
      toast.success(form.actif ? "Offre Hotel par Heure activee" : "Offre desactivee");
      onChanged?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Echec de l'enregistrement"); } finally { setBusy(false); }
  };

  const invite = async () => {
    setBusy(true);
    try { const r = await inviteDayUse(hotel.id); toast.success(`Invitation SMS envoyee (${r.sms_info})`); }
    catch (e) { toast.error(e.response?.data?.detail || "Echec de l'envoi"); } finally { setBusy(false); }
  };

  return (
    <div className="glass-card p-5 mb-6" data-testid="day-use-card">
      <div className="flex items-center justify-between gap-3">
        <h3 className="font-bold inline-flex items-center gap-2"><Clock size={16} className="text-orange-500" /> Offre « Hotel par Heure » (day-use)</h3>
        <label className="inline-flex items-center gap-2 text-sm font-semibold">
          <input type="checkbox" checked={form.actif} onChange={(e) => set("actif", e.target.checked)} data-testid="day-use-toggle" /> {form.actif ? "Active" : "Inactive"}
        </label>
      </div>
      <p className="text-xs text-[var(--ink-soft)] mt-1">Creneaux de jour a prix reduit (-30 % minimum garanti), sans carte ni acompte : le client paie sur place, annulation gratuite avant le debut.</p>
      <div className="grid grid-cols-3 gap-3 mt-3 text-sm">
        <label>Debut<input type="number" min={0} max={23} value={form.heure_debut} onChange={(e) => set("heure_debut", Number(e.target.value))} data-testid="day-use-start" /></label>
        <label>Fin<input type="number" min={1} max={24} value={form.heure_fin} onChange={(e) => set("heure_fin", Number(e.target.value))} data-testid="day-use-end" /></label>
        <label>Reduction %<input type="number" min={30} max={70} value={form.reduction} onChange={(e) => set("reduction", Number(e.target.value))} data-testid="day-use-discount" /></label>
      </div>
      <div className="flex gap-2 mt-3">
        {DUREES.map((d) => (
          <button key={d} type="button" onClick={() => toggleDuree(d)} className={`chip ${form.durees.includes(d) ? "!bg-orange-500 !text-white" : ""}`} data-testid={`day-use-duree-${d}`}>{d} h</button>
        ))}
      </div>
      <div className="flex gap-2 mt-4">
        <button onClick={save} disabled={busy} className="btn-primary !py-2 text-sm" data-testid="day-use-save">{busy ? "Enregistrement..." : "Enregistrer"}</button>
        <button type="button" onClick={invite} disabled={busy || !hotel.manager_phone} className="chip" title={hotel.manager_phone ? "" : "Renseignez d'abord le telephone du gerant"} data-testid="day-use-invite">Inviter le gerant par SMS (activation 1 clic)</button>
      </div>
    </div>
  );
};
